import {MetricCard} from '../../../components/metric-card/metric-card.jsx'
import {useDashboardData} from '../dashboard-hooks.js'
import styles from './compact.module.scss'

export function CompactLayout() {
    const {metrics} = useDashboardData()
    const w = metrics.data?.weather || {}
    const c = metrics.data?.climate || {}

    const cells = [
        {id: 'climate.temperature', label: 'In · Temp', value: c.temperatureInside, unit: '°C'},
        {id: 'climate.humidity', label: 'In · RH', value: c.humidityInside, unit: '%'},
        {id: 'weather.temperature', label: 'Out · Temp', value: w.temperature, unit: '°C'},
        {id: 'weather.humidity', label: 'Out · RH', value: w.humidity, unit: '%'},
        {id: 'weather.windSpeed', label: 'Wind', value: w.windSpeed, unit: 'm/s'},
        {id: 'weather.light', label: 'Light', value: w.light, unit: 'lux'},
        {id: 'weather.pressure', label: 'Pressure', value: w.pressure, unit: 'hPa'},
        {id: 'weather.rainfall', label: 'Rain', value: w.rainfall, unit: 'mm'}
    ]

    return (
        <div className={styles.layout}>
            <header className={styles.header}>
                <p className={styles.eyebrow}>Compact</p>
                <h1 className={styles.title}>Dashboard</h1>
            </header>
            <div className={styles.grid}>
                {cells.map(c => (
                    <MetricCard
                        key={c.id}
                        metricId={c.id}
                        label={c.label}
                        value={c.value}
                        unit={c.unit}
                        className={styles.tile}
                    />
                ))}
            </div>
        </div>
    )
}
